import { IPromptContext } from "./interfaces";

export class AIHelper {

  public static getPromptForThermicIndex(thermicIndexParameters: IPromptContext): string {
    let prompt = `Sen bir meteorolog ve hava uzmanısın. Paragliding pilotları için uçuş emniyeti, termik potansiyeli ve tehlikeleri değerlendiriyorsun. Aşağıdaki verileri kullanarak uçuş saatinde bölgedeki koşulları analiz etmeni istiyorum:\n\n`;
    prompt += `- Model rakımı: ${thermicIndexParameters.elevation} metre\n`;
    prompt += `- Saat: ${thermicIndexParameters.timeHours} \n`;
    prompt += `- Tarih: ${thermicIndexParameters.date} \n`;
    prompt += `- Enlem: ${thermicIndexParameters.latitude} \n`;
    prompt += `- Boylam: ${thermicIndexParameters.longitude} \n`;
    prompt += `- 850hPa termik indeksi: ${thermicIndexParameters.tI850hPa} \n`;
    prompt += `- 850hPa bağıl nem: ${thermicIndexParameters.relativeHumidity850hPa} %\n`;
    prompt += `- 850hPa sıcaklık: ${thermicIndexParameters.temp850hPa} %\n`;
    prompt += `- 850hPa rüzgar yönü: ${thermicIndexParameters.winDirection850hPa} °, hızı: ${thermicIndexParameters.winSpeed850hPa} km/s\n`;
    prompt += `- 700hPa termik indeksi: ${thermicIndexParameters.tI700hPa} \n`;
    prompt += `- 700hPa bağıl nem: ${thermicIndexParameters.relativeHumidity700hPa} %\n`;
    prompt += `- 700hPa sıcaklık: ${thermicIndexParameters.temp700hPa} %\n`;
    prompt += `- 700hPa rüzgar yönü: ${thermicIndexParameters.winDirection700hPa} °, hızı: ${thermicIndexParameters.winSpeed700hPa} km/s\n`;
    prompt += `- Bulut örtüsü: ${thermicIndexParameters.cloudCover} %\n`;
    prompt += `- CAPE: ${thermicIndexParameters.hourCape} J/kg\n`;
    prompt += `- Konvektif bulut tabanı (base): ${thermicIndexParameters.hourConvectiveCloudBase} metre\n\n`;
    prompt += `Lütfen aşağıdaki konular hakkında açık ve sade bir dille Türkçe olarak yorum yap:\n\n`;
    prompt += `1. Termik aktivite potansiyeli nedir? (güçlü, orta, zayıf)\n`;
    prompt += `2. Bu verilerle hangi pilot seviyeleri için uçuş uygundur? (örneğin P2, P3, P4)\n`;
    prompt += `3. CAPE değeri ve konvektif bulut tabanına göre olası riskler var mı? (turbulans, aşırı yükseliş, CB tehlikesi)\n`;
    prompt += `4. Rüzgar yönü ve şiddeti uçuş emniyetini nasıl etkiler?\n`;
    prompt += `5. Genel uçuş önerilerin nelerdir?\n\n`;
     prompt += `Konum Adını başta yaz`;
    prompt += `Yorumlarını açık, teknik ama pilot dostu bir dille yaz. Kısa kısa cümleler kullan. Uygun yerlerde pilotlara öneri ver.\n`;
    return prompt;
  }
}
